module.exports = __webpack_public_path__ + "static/media/Power_thumb.5d5582a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/words/Power_thumb.png
// module id = 378
// module chunks = 0